/**
 * Maintenance Action to be performed.
 * tag: 712
 * @readonly
 * @enum {number} (int)
 */
export enum PosMaintAction {
  New = 1,
  Replace = 2,
  Cancel = 3,
  Reverse = 4,
}
